// @mui
import { alpha, styled, useTheme } from '@mui/material/styles';
//
import { LabelColor, LabelVariant } from './types';

// ----------------------------------------------------------------------

export const StyledLabel = styled('span')(({
  color = 'default',
  variant = 'soft',
}: {
  color?: LabelColor;
  variant?: LabelVariant;
}) => {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  const filledVariant = variant === 'filled';

  const outlinedVariant = variant === 'outlined';

  const softVariant = variant === 'soft';

  const defaultStyle = {
    ...(color === 'default' && {
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
      }),
      // SOFT
      ...(softVariant && {
        color: isLight ? theme.palette.text.primary : theme.palette.common.white,
        backgroundColor: alpha(theme.palette.grey[500], 0.16),
      }),
    }),
  };

  const colorStyle = {
    ...(color !== 'default' && {
      // FILLED
      ...(filledVariant && {
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
      }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        color: theme.palette[color].main,
        border: `1px solid ${theme.palette[color].main}`,
      }),
      // SOFT
      ...(softVariant && {
        color: theme.palette[color][isLight ? 'dark' : 'light'],
        backgroundColor: alpha(theme.palette[color].main, 0.16),
      }),
    }),
  };

  return {
    height: 24,
    minWidth: 22,
    lineHeight: 0,
    borderRadius: 6,
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    textTransform: 'capitalize',
    padding: theme.spacing(0, 1),
    color: theme.palette.grey[800],
    fontSize: theme.typography.pxToRem(12),
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.grey[300],
    fontWeight: theme.typography.fontWeightBold,
    ...colorStyle,
    ...defaultStyle,
  };
});
